import { useState } from "react";

// Shows a complete email document in an iframe so its own <style> block can't restyle
// the admin panel, sized to its content. Scripts never run inside it.
const EmailPreviewFrame = ({ html, title = "Email preview", minHeight = 200 }) => {
  const [height, setHeight] = useState(minHeight);

  const fitToContent = (event) => {
    const body = event.target.contentDocument?.body;
    if (body) {
      setHeight(Math.max(minHeight, body.scrollHeight + 32));
    }
  };

  return (
    <iframe
      title={title}
      srcDoc={html}
      sandbox="allow-same-origin"
      onLoad={fitToContent}
      style={{
        width: "100%",
        height,
        border: "1px solid #f0f0f0",
        borderRadius: 6,
        background: "#fff",
      }}
    />
  );
};

export default EmailPreviewFrame;
